import { sideVariableHelpers as S } from "../../helpers/templateSidesFunctions.js";
const d = (c, F, v, b, h) => {
  if (!c)
    return null;
  const r = {}, i = h && Object.values(h).flatMap(({ groups: n }) => n);
  return c.variables.length && c.variables.forEach(({ id: n, sideId: e, sideName: l }) => {
    const f = F.find((t) => t.id === e);
    if (!(f && f.tattrFolders.find(({ tattrs: a }) => !!a.find((s) => s.id === n)))) {
      if (r[e] || (r[e] = { id: e, name: l, tattrFolders: [], tables: [], carticles: [] }), v && v[n]) {
        const t = i == null ? void 0 : i.find(({ items: a }) => a.includes(n));
        r[e].tattrFolders = S.addVariableToFolder(
          r[e].tattrFolders,
          v[n],
          { id: t == null ? void 0 : t.groupId, name: t == null ? void 0 : t.name }
        );
      } else if (b && b[n]) {
        const t = i == null ? void 0 : i.find(({ groupId: a }) => a === b[n].folderid);
        r[e].tattrFolders = S.addVariableToFolder(
          r[e].tattrFolders,
          b[n],
          { id: t == null ? void 0 : t.groupId, name: t == null ? void 0 : t.name }
        );
      }
    }
  }), c.tables.length && c.tables.forEach(({ id: n, name: e, sideId: l, sideName: f, resized: t, columns: a, total: s, showTotalRow: m }) => {
    r[l] || (r[l] = { id: l, name: f, tattrFolders: [], tables: [], carticles: [] }), r[l].tables.find((o) => o.id === n) || r[l].tables.push({
      id: n,
      name: e,
      resized: t,
      columns: a,
      total: s,
      showTotalRow: m
    });
  }), c.variations.length && c.variations.forEach(({ id: n, sideId: e, sideName: l, title: f, multiple: t, parents: a, variants: s }) => {
    const m = F.find((o) => o.id === e);
    if (m && m.carticles.find((E) => E.id === n))
      return;
    r[e] || (r[e] = { id: e, name: l, tattrFolders: [], tables: [], carticles: [] }), r[e].tables.find((o) => o.id === n) || r[e].carticles.push({
      id: n,
      title: f,
      multiple: t,
      parents: a,
      variants: s
    });
  }), Object.values(r);
};
export {
  d as default
};
